import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

import { WeatherWall, CreateWeatherWallDto } from 'types';

export const createWeatherWall = (
  data: CreateWeatherWallDto
): Promise<WeatherWall> => {
  return axios.post('/api/weather/walls', data);
};

type UseCreateWeatherWallOptions = {
  config?: MutationConfig<typeof createWeatherWall>;
};

export const useCreateWeatherWall = ({
  config,
}: UseCreateWeatherWallOptions) => {
  return useMutation({
    onError: (_, __, context: any) => {
      if (context?.previousWeatherWalls) {
        queryClient.setQueryData(
          ['weatherWalls'],
          context.previousWeatherWalls
        );
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['weatherWalls']);
    },
    ...config,
    mutationFn: createWeatherWall,
  });
};
